import React from 'react';
import { ArrowRightIcon, CarFrontIcon, RepeatIcon, ShieldCheckIcon, TruckIcon, UsersIcon, WalletIcon } from 'lucide-react';
import { Heading, Kicker, Lead, Section } from './ui';
import { trackPixelEvent } from '../../utils/metaPixel';
import { paths } from '../../data/vcars';
const ICONS = {
  car: CarFrontIcon,
  repeat: RepeatIcon,
  wallet: WalletIcon,
  users: UsersIcon,
  truck: TruckIcon,
  shield: ShieldCheckIcon
};
export function PathsSection() {
  return <Section id="opciones" className="bg-[#08090b]" data-id="element-50" data-mp="2i0tyg8n1afnq">
      <Kicker data-id="element-51" data-mp="2i0aszrekljql">Elegí tu caso</Kicker>
      <Heading className="mt-4 text-white" data-id="element-52" data-mp="241b0u9rummpo">¿Qué estás buscando hoy?</Heading>
      <Lead className="mt-4 max-w-xl text-white/55" data-id="element-53" data-mp="243f4qrpqzlpy">
        Elegí la opción que más se parece a tu situación y escribinos para
        ayudarte mejor.
      </Lead>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-54" data-mp="slcpfz977ola">
        {paths.map(path => {
        const Icon = ICONS[path.icon];
        return <div key={path.title} className="flex flex-col bg-[#12141a] p-6 sm:p-7" data-id="element-55" data-mp="62azmoibsb61">
              <Icon className="h-7 w-7 text-[#5b83ff]" strokeWidth={1.8} data-id="element-56" data-mp="14sxbgytcu70" />
              <h3 className="font-display mt-4 text-lg font-bold leading-tight text-white sm:text-xl" data-id="element-57" data-mp="g1jrnbtmrfpr">
                {path.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55 sm:text-base" data-id="element-58" data-mp="b0ma91gg2ppb">
                {path.text}
              </p>
              <a href={path.url} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('Contact', {
            content_name: path.title
          })} className="mt-auto flex items-center gap-2 pt-6 text-sm font-semibold text-[#7f9bff] transition-colors duration-150 ease-out hover:text-white sm:text-base" data-id="element-59" data-mp="k2lv64ukydxj">
                {path.cta}
                <ArrowRightIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-60" data-mp="13sfqgswi7b6i" />
              </a>
            </div>;
      })}
      </div>
    </Section>;
}